import EATable from "../../EATable";
import React, {useEffect, useState} from "react";
import {createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import {useHttp} from "../../../services/HttpService";
import EABetriebsakteMainContainer from "../EABetriebsakteMainContainer";
import {createCustomTextLink} from "../../../utils/RouteUtils";
import {ENTLASTUNG} from "../../../consts/fachobjekt";
import {useHistory} from "react-router-dom";
import {getEntlastungUebersichtEndpoint} from "../../../services/AnlagenService";
import EAFileUploadDialog from "../../EAFileUploadDialog";
import {getExportEntlastungsanlagenEndpoint, postImportEntlastungsanlagenEndpoint} from "../../../services/BetriebeService";
import {toast} from "react-toastify";
import EAButtonBar from "../../EAButtonBar";
import EADownloadButton from "../../EADownloadButton";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../../consts/funktionaleRollen";
import EAButton from "../../EAButton";
import {getEntlastungsanlagenartEndpoint, getEntlastungstypEndpoint} from "../../../services/WertelistenService";
import EACombobox from "../../EACombobox";
import "../../../styles/components/entlastungUebersicht.css";

export default function EntlastungUebersicht(props) {
    const history = useHistory();
    const [importAnlagenOpen, setImportAnlagenOpen] = useState(false);
    const [{
        data: entlastungenData,
        loading: entlastungenDataLoading
    }] = useHttp(getEntlastungUebersichtEndpoint(props.betriebsId));

    const [abwasseranlageFilter, setAbwasseranlageFilter] = useState();
    const [anlagenartFilter, setAnlagenartFilter] = useState();
    const [entlastungstypFilter, setEntlastungstypFilter] = useState();
    const [entlastungsanlagenartOptionen] = useHttp(getEntlastungsanlagenartEndpoint);
    const [entlastungstypOptionen] = useHttp(getEntlastungstypEndpoint);
    const [filteredData, setFilteredData] = useState([]);

    const allLoaded = entlastungenDataLoading;

    const linkColumnComponentProvider = (row) => createCustomTextLink(row.bezeichnung, ENTLASTUNG, row.id, history);

    const handleFileUploadError = (error) => toast.error(error ? error : "Die Misch-/Niederschlagswasseranlagen konnten nicht importiert werden!");

    const handleFileUploadSuccessed = () => {
        setImportAnlagenOpen(false);
        toast.success("Die Misch-/Niederschlagswasseranlagen wurden erfolgreich importiert");
        props.reloadNavigation();
    }

    useEffect(() => {
        if (entlastungenData) {
            setFilteredData([
                ...entlastungenData.filter((item) => {
                    return (
                        (
                            !abwasseranlageFilter || abwasseranlageFilter.id === item.id
                        ) && (
                            !anlagenartFilter || anlagenartFilter.id === item.anlagenart.id
                        ) && (
                            !entlastungstypFilter || entlastungstypFilter.id === item.entlastungstyp.id
                        )

                    );
                }),
            ]);
        }
    }, [entlastungenData, props.anlageId, entlastungenDataLoading, anlagenartFilter, entlastungstypFilter, abwasseranlageFilter]);

    const columns = [
        createColumn("gemarkung", "Gemarkung"),
        createComponentColumn("bezeichnung", linkColumnComponentProvider, "Abwasseranlage"),
        createColumn("anlagenart.value", "Anlagenart"),
        createColumn("entlastungstyp.value", "Entlastungstyp"),
        createColumn("aufnahme.value", "Aufnehmende Anlage"),
        createColumn("anlagenstatus.value", "Status")
    ];

    return (
        <div className={"viewScrollContainer"}>
            <EABetriebsakteMainContainer className={"tabsheet-content-margin"}>
                <div className={"entlastungUebersicht-filter"}>
                    <span className={"entlastungUebersicht-filterText"}>
                        Liste Filtern nach
                    </span>
                    <EACombobox
                        className={"entlastungUebersicht-filterItem"}
                        id="abwasseranlageFilter"
                        label="Abwasseranlage"
                        options={entlastungenData}
                        getOptionLabel={(option) =>
                            option && option.bezeichnung
                        }
                        onChange={(_event, newValue) => {
                            setAbwasseranlageFilter(newValue);
                        }}
                    />
                    <EACombobox
                        className={"entlastungUebersicht-filterItem"}
                        id="entlastungsartFilter"
                        label="Anlagenart"
                        options={entlastungsanlagenartOptionen.data}
                        getOptionLabel={(option) =>
                            option && option.value
                        }
                        onChange={(_event, newValue) => {
                            setAnlagenartFilter(newValue);
                        }}
                    />
                    <EACombobox
                        className={"entlastungUebersicht-filterItem"}
                        id="entlastungstypFilter"
                        label="Entlastungstyp"
                        options={entlastungstypOptionen.data}
                        getOptionLabel={(option) =>
                            option && option.value
                        }
                        onChange={(_event, newValue) => {
                            setEntlastungstypFilter(newValue);
                        }}
                    />
                </div>
                <EATable columns={columns} data={filteredData} loading={entlastungenDataLoading}/>
                {props.betriebsId && <div>
                    {props.modus === "s" && (
                        <EAFileUploadDialog
                            open={importAnlagenOpen}
                            onClose={() => setImportAnlagenOpen(false)}
                            label="Misch-/Niederschlagswasseranlagen importieren"
                            onSuccess={handleFileUploadSuccessed}
                            onError={handleFileUploadError}
                            withBezeichnung={false}
                            uploadPath={postImportEntlastungsanlagenEndpoint(props.betriebsId)}
                        />
                    )}
                    <EAButtonBar style={{marginTop: "var(--vertical-spacing)"}}>
                        <EADownloadButton
                            id="export-entlastungsanlagen"
                            label="Misch-/Niederschlagswasseranlagen exportieren"
                            loading={allLoaded}
                            url={getExportEntlastungsanlagenEndpoint(props.betriebsId)}
                        />
                        {userHasAnyRole([BETREIBER, BEAUFTRAGTER, FACHADMIN, ZUST_SBD, SYSTEMADMIN]) && props.modus === "s" &&
                            <EAButton id={"import-entlastungsanlagen-dlg-button"}
                                      label={"Misch-/Niederschlagswasseranlagen importieren"}
                                      loading={allLoaded}
                                      onClick={() => setImportAnlagenOpen(true)}
                            />}
                    </EAButtonBar>
                </div>
                }
            </EABetriebsakteMainContainer>
        </div>
    );
}
